import { IGlobalResponse } from '../interfaces/error.interface';

export namespace GlobalResponse {
  export const isIGlobalResponse = (obj: any): obj is IGlobalResponse => {
    return obj?.app?.code && obj?.app?.name && obj?.app?.description && obj?.status;
  };
}
